import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";

// Daftarkan komponen yang dibutuhkan dari Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const UserChart = ({ data }) => {
  // Ekstraksi data untuk chart
  const userNames = data.map((user) => user.nama_provinsi);
  const userAges = data.map((user) => user.total);

  // Konfigurasi data untuk chart
  const chartData = {
    labels: userNames,
    datasets: [
      {
        label: "Persentase",
        data: userAges, // Data umur
        backgroundColor: ["rgba(75, 192, 192, 0.2)", "rgba(255, 99, 132, 0.2)", "rgba(54, 162, 235, 0.2)"],
        borderColor: ["rgba(75, 192, 192, 1)", "rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
      },
    ],
  };

  // Konfigurasi opsi untuk chart
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      y: {
        beginAtZero: true, // Mulai sumbu Y dari 0
      },
    },
  };

  

  return (
    <div style={{ width: "60%", backgroundColor: "#fff", padding: "10px", borderRadius: "5px", lineHeight: "1.2" }}>
      <h2>Stunting</h2>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default UserChart;
